var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.683,
    height: 18,
    viewBox: "0 0 24.683 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-password-show-svgrepo-com",
    transform: "translate(0.342 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38932",
    "data-name": "Path 38932",
    d: "M1,12S5,4,12,4s11,8,11,8",
    fill: "none",
    stroke: "#b1b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38933",
    "data-name": "Path 38933",
    d: "M1,12s4,8,11,8,11-8,11-8",
    fill: "none",
    stroke: "#b1b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9 9)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.45178de26f8240ce8e7b64dcdb232074.svg";
export { ForwardRef as ReactComponent };